import React from "react";
import styled, { css } from "styled-components";
import { px2rem } from "utils/browser/resizer";
import { AssetImageUrl } from "assets/imgUrl";

const DownloadAppWrap = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${px2rem(9)};
  margin-bottom: ${px2rem(9)};
  width: 100%;
  min-height: ${px2rem(63)};
  background: url(${AssetImageUrl["bg@3x.png"]}) no-repeat;
  background-size: cover;
  padding: ${px2rem(12)} 0 ${px2rem(12)} 0;
  font-size: ${px2rem(12)};
  > img:first-child {
    margin: 0 ${px2rem(9)} 0 ${px2rem(12)};
  }
  > img:last-child {
    margin-right: ${px2rem(20)};
  }
`;

const DownloadText = styled.div`
  flex: 1;
  > div:first-child {
    font-weight: 800;
    color: ${(props) => props?.theme?.mainFontColor};
  }
  ${(props: { hasLowPriceCountryPriceOff: boolean }) =>
    props.hasLowPriceCountryPriceOff &&
    css`
      > div:last-child {
        font-weight: 500;
        color: ${(props) => props?.theme?.mainFontColor};
        > span {
          color: ${(props) => props?.theme?.primaryColor};
          font-family: Avenir-Heavy, Avenir;
          font-weight: 800;
        }
      }
    `}
`;

const PriceOffContainer = styled.div`
  & > span {
    color: ${(props) => props?.theme?.primaryColor};
    font-weight: 800;
  }
`;

interface DownloadAppProps {
  lowPriceCountryPriceOff: string;
}

const DownloadApp = (props: DownloadAppProps) => {
  const { lowPriceCountryPriceOff } = props;

  const goPage = (path: string) => {
    window.location.href = path;
  };

  return (
    <DownloadAppWrap onClick={() => goPage("https://s.ouku.com/3ui8/fos0tqb5")}>
      <img
        src={AssetImageUrl["logo@3x.png"]}
        width={40}
        height={40}
        alt="ouku"
        loading="lazy"
      />
      <DownloadText hasLowPriceCountryPriceOff={!!lowPriceCountryPriceOff}>
        <div>OUKU</div>
        <PriceOffContainer
          dangerouslySetInnerHTML={{
            __html: lowPriceCountryPriceOff
              ? lowPriceCountryPriceOff
              : "Extra <span>10% OFF</span> on APP",
          }}
        />
      </DownloadText>
      <img
        src={AssetImageUrl["ic_download@3x.png"]}
        width={24}
        height={24}
        alt="download"
        loading="lazy"
      />
    </DownloadAppWrap>
  );
};

export default DownloadApp;
